import { render } from "./new-cybersquad-slot.vue?vue&type=template&id=3299b4d9&scoped=true&ts=true"
import script from "./new-cybersquad-slot.vue?vue&type=script&lang=ts"
export * from "./new-cybersquad-slot.vue?vue&type=script&lang=ts"

import "./new-cybersquad-slot.vue?vue&type=style&index=0&id=3299b4d9&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3299b4d9"]])

export default __exports__